var map = {
	"./address-book-icon.svg": "fd90",
	"./backpack.svg": "1516",
	"./ball.svg": "c2e7",
	"./baseball.svg": "6c50",
	"./bicycle-bike.svg": "a51e",
	"./boots.svg": "1b0f",
	"./brightness.svg": "9b04",
	"./cap-front.svg": "1852",
	"./cap-side.svg": "df02",
	"./cricket.svg": "558e",
	"./cycling.svg": "e676",
	"./downhill-skiing.svg": "fa2e",
	"./dribble-logo.svg": "17b8",
	"./fishing-phishing.svg": "2864",
	"./flag-score.svg": "114b",
	"./football.svg": "f867",
	"./golf.svg": "bfcc",
	"./gymnastics.svg": "094d",
	"./hanger.svg": "6622",
	"./hiking.svg": "8df42",
	"./hockey.svg": "0bf7",
	"./holiday-vacation-beach-umbrella.svg": "1ade",
	"./ice-skating.svg": "25b9",
	"./kayaking.svg": "3c8f",
	"./leaf.svg": "9a0e",
	"./martial-arts.svg": "71fd",
	"./meditation.svg": "4c5a",
	"./module-three.svg": "c7e2",
	"./motorsports-helmet.svg": "af98",
	"./nordic-walking.svg": "1db7",
	"./notification-icon.svg": "2dcc",
	"./orders-icon.svg": "9340",
	"./paint-palette.svg": "8f77",
	"./playground.svg": "8b81",
	"./potted-flower-tulip.svg": "07e5",
	"./roller-skating.svg": "4ab3",
	"./running.svg": "9100",
	"./scuba-diving.svg": "83dc",
	"./settings-icon.svg": "6757",
	"./shirt.svg": "f969",
	"./shopping-bag-hand-bag.svg": "2e03",
	"./shorts.svg": "0efe",
	"./skateboarding.svg": "e1dd",
	"./sledding.svg": "5d4f",
	"./snow-flake.svg": "9416",
	"./snowboarding.svg": "8438",
	"./soccer.svg": "e820",
	"./sock.svg": "43db",
	"./sprint.svg": "fe5c",
	"./stadium.svg": "a625",
	"./surfing.svg": "7c57",
	"./swimming.svg": "aed5",
	"./tennis.svg": "4817",
	"./user-circle.svg": "3eeb",
	"./volleyball.svg": "bdcd",
	"./walking-steps.svg": "12e0",
	"./whistle.svg": "cb69"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2886";